<template>
  <div>
    <el-button
      @click="daochu"
      type="primary"
      style="background: #f78989; border-color: #f78989; margin-bottom: 20px"
      >导出</el-button
    >
    <el-table :data="list" border stripe style="width: 100%">
      <el-table-column
        min-width="100%"
        prop="productCode"
        label="产品编码"
      >
      </el-table-column>
      <el-table-column prop="productName" label="产品名称"> </el-table-column>
      <!--  <el-table-column
      prop="factory"
      label="厂区">
    </el-table-column> -->
      <el-table-column prop="trayCase" label="每托箱数"> </el-table-column>
      <!--     <el-table-column
      prop="price"
      label="单价">
    </el-table-column> -->
      <el-table-column prop="caseNum" label="标准箱件数"> </el-table-column>
      <el-table-column prop="zeroCaseQty" label="箱件数"> </el-table-column>
      <el-table-column prop="orderQuantity" label="订单数量"> </el-table-column>
      <el-table-column prop="boxQty" label="箱数"> </el-table-column>
      <!--      <el-table-column
      prop="approvalQty"
      label="评审数">
    </el-table-column>
       <el-table-column
      prop="cancelQty"
      label="红冲数数">
    </el-table-column> -->
      <el-table-column prop="sorQty" label="已转发货单数量"> </el-table-column>
      <el-table-column prop="unit" label="单位"> </el-table-column>
      <el-table-column prop="amount" label="行金额/元"> </el-table-column>
      <el-table-column prop="weight" label="行重量/吨"> </el-table-column>
      <el-table-column prop="pz" label="品种"> </el-table-column>

      <el-table-column prop="gg" label="规格"> </el-table-column>
      <el-table-column prop="xs" label="形式"> </el-table-column>
      <el-table-column prop="cz" label="材质"> </el-table-column>
      <el-table-column prop="bm" label="表面处理"> </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  created() {
    let orderSeq = this.$route.params.id;
    this.$axios
      .postReq("/meide/REST/ajaxOrderReport", {
        postType: "queryOrderDetail",
        orderSeq,
      })
      .then((res) => {
        this.list = res.data;
      });
  },
  methods: {
    daochu() {
      let orderSeq = this.$route.params.id;
      this.$axios
        .postReq("/meide/REST/ajaxOrderExport", {
          postType: "exportOrderDetail",
          orderSeq,
        })
        .then((res) => {
          if (res.success == "true") {
            let url = res.url;
            window.open(url);
          } else {
            // this.$message.error(res.ErrorText);
          }
        });
    },
  },
  data() {
    return {
      list: [],
    };
  },
};
</script>
